import message from "./message"

const handlers = [
  message,
]

export default handlers
